<template>
  <div id="ownerApplyContainer">
    <!--  style="height:48px;position:fixed;top:0;width:100%" -->
    <div style="position: sticky; top: 0">
      <van-tabs
        v-model="activeNum"
        lazy-render
        title-active-color="rgba(51, 51, 51, 1)"
        title-inactive-color="#999999"
        @change="onClickChange(activeNum)"
        animated
      >
        <van-tab
          v-for="index in tabApplyList"
          :key="index.name"
          :name="index.name"
          :title="index.title"
        ></van-tab>
      </van-tabs>
    </div>

    <div v-if="hireList.length != 0" class="my_hire_concent_box">
      <!-- 分页 -->
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="暂无更多"
        @load="onLoad"
        :immediate-check="false"
      >
        <!-- 销售申请 -->
        <div id="my_hire_first">
          <div class="my_hire_list">
            <div
              class="my_hire_list_item"
              id="my_hire_record"
              v-for="(item, index) in hireList"
              :key="index"
            >
              <div class="Sales_i between">
                <div class="avar">
                  <img :src="item.avatarUrl" alt />
                </div>
                <div class="betweenBottoms my_hier_size">
                  {{ item.nickName }}
                </div>
              </div>
              <div class="Sales_i between">
                <div class="titleL">申请编号</div>
                <div class="betweenBottoms my_hier_size">
                  {{ item.id }}
                </div>
              </div>
              <div class="Sales_i between">
                <div class="titleL">云电编号</div>
                <div class="betweenBottoms my_hier_size">
                  {{ item.ydCode }}
                </div>
              </div>
              <div class="Sales_i between">
                <div class="titleL">申请时间</div>
                <div class="betweenBottoms my_hier_size">
                  {{ item.applyTime }}
                </div>
              </div>
              <div class="Sales_i between">
                <div class="titleL">审批状态</div>
                <div class="betweenBottoms my_hier_size">
                  {{ getChinese(item.status) }}
                </div>
              </div>

              <!-- 已通过  -->
              <div class="Sales_Button between" v-if="item.status == 4">
                <div class="titleL">审批时间</div>
                <div class="betweenBottoms my_hier_size">
                  {{ item.examineTime }}
                </div>
              </div>
              <!--  已驳回 -->
              <div
                class="Sales_i between"
                v-if="item.status == 3 || item.status == 5"
              >
                <div class="titleL">审批时间</div>
                <div class="betweenBottoms my_hier_size">
                  {{ item.examineTime }}
                </div>
              </div>
              <div
                class="Sales_Button between"
                v-if="item.status == 3 || item.status == 5"
              >
                <div class="titleL">驳回原因</div>
                <div class="betweenBottoms my_hier_size">
                  {{ item.rejectedReason }}
                </div>
              </div>
              <!-- <div class="Sales_Button" @click="onClickItem(item)">
                <van-button
                  type="danger"
                  block
                  native-type="submit"
                  style="border-radius: 8px"
                  >确认</van-button
                >
              </div> -->
            </div>
          </div>
        </div>
      </van-list>
    </div>
    <!-- loading -->

    <!-- <div class="wrapper"> -->
    <loading v-if="isLoading"></loading>
    <!-- </div> -->
    <!-- 空页面 -->
    <div class="noShares" v-if="hireList.length == 0">
      <div class="noSalePage">
        <img src="../../../assets/images/noApply.png" alt />
      </div>
      <div class="noShareText">暂无审批</div>
    </div>
  </div>
</template>

<script>
import {
  Tab,
  Tabs,
  Toast,
  Dialog,
  List,
  Loading,
  Overlay,
  Popup,
  Icon,
  Picker,
} from "vant";
import loading from "../../components/loading/loading";
import { mapGetters } from "vuex";
import service from "../../api/ownerApproval/index";
import ownerService from "../../api/ownerApply/index";
export default {
  components: {
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [Toast.name]: Toast,
    [Dialog.Component.name]: Dialog.Component,
    [List.name]: List,
    [Loading.name]: Loading,
    [Overlay.name]: Overlay,
    [Popup.name]: Popup,
    [Icon.name]: Icon,
    [Picker.name]: Picker,
    loading,
  },
  props: {},
  data() {
    return {
      tabApplyList: [
        { name: "1,2", title: "处理中" },
        { name: 4, title: "已通过" },
        { name: "3,5", title: "已驳回" },
      ],
      activeNum: "1,2",
      isLoading: false,
      page: 1,
      pageSize: 20,
      loading: false,
      finished: false,
      hireList: [],
    };
  },
  watch: {},
  computed: {},
  methods: {
    // 销售申请tab切换
    onClickChange(activeNum) {
      this.page = 1;
      this.pageSize = 20;
      this.isLoading = true;
      this.finished = false;
      this.activeNum = activeNum;
      this.hireList = [];
      this.getlist();
    },
    // 确认
    // onClickItem(item) {

    // },
    getChinese(status) {
      switch (status) {
        case 1:
          return "待确认";
        case 2:
          return "待审批";
        case 3:
          return "已驳回";
        case 4:
          return "已通过";
        case 5:
          return "已驳回";

        default:
          return status;
      }
    },
    //下拉加载列表
    getlist() {
      this.finished = false;
      this.loading = false;
      this.onLoad();
    },
    onLoad() {
      try {
        service
          .GetUserApprovalsApprovalsList(
            this.activeNum,
            this.page,
            this.pageSize
          )
          .then((res) => {
            if (res.statusCode == 200) {
              const results = res.data.items;
              this.hireList.push(...results);
              this.isLoading = false;
              this.loading = false;
              this.finished = false;
              if (res.data.totalCount > this.hireList.length) {
                // 有，则更新获取下一个数据的页码
                this.page++;
              } else {
                this.finished = true;
              }
              // if (results.length > 0) {
              //   // 有，则更新获取下一个数据的页码
              //   this.page++;
              // } else {
              //   // 没有，则将加载状态finished设置为结束
              //   this.finished = true;
              // }
            } else {
              // this.isLoading = false
              Toast(errors);
            }
          })
          .catch((err) => {
            // this.isLoading = false
            // Toast(err);
          });
      } catch (errors) {
        this.isLoading = false;
        Toast(errors);
      } finally {
        // this.isLoading = false
      }
    },
  },
  created() {
    this.getlist();
  },
  mounted() {
    // this.onLoad()
  },
  computed: {
    ...mapGetters(["agentShow"]),
    AgentIsShow() {
      return this.agentShow == null ? false : this.agentShow.isShow;
    },
  },
};
</script>
<style lang="less">
#ownerApplyContainer {
  width: 100%;
  min-height: 100vh;
  background: #f8f8f8;
  .noSalePage {
    width: 80px;
    margin: auto;
  }
  // .my_hire_concent_box {
  // padding-bottom: 60px;
  // padding-top: 48px;
  // }
  .van-list__finished-text {
    height: 44px;
    line-height: 44px;
    font-size: 12px;
  }
  .van-tabs__wrap {
    height: 48px !important;
  }
  .avar {
    width: 48px;
    height: 48px;
    img {
      border-radius: 50%;
    }
  }
  .titleL {
    // flex: 1;
    width: 160px;
    // margin-right: 20px;
  }
  .my_hier_size {
    line-height: 22px;
    flex: 1;
    text-align: end;
    word-break: break-all;
  }
  .noShares {
    height: 100;
    width: 100%;
    text-align: center;
    font-size: 12px;
    color: #92909a;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  .noShareText {
    padding-top: 24px;
  }
  #my_hire_first {
    .my_hire_list_item:first-child {
      margin-top: 0px;
    }
    #my_hire_record:first-child {
      margin-top: 12px;
    }
    .my_hire_list {
      padding: 0 12px;
      .SalesPerformance_item {
        padding: 20px;
        // height: 40px;
        background: #ffffff;
        box-shadow: 0px 4px 8px 0px #e6e6e6;
        border-radius: 8px;
      }
      .my_hire_list_item {
        padding-left: 16px;
        padding-right: 16px;
        // height: 40px;
        background: #ffffff;
        // box-shadow: 0px 4px 8px 0px #e6e6e6;
        border-radius: 8px;
        margin-top: 8px;
        .Sales_i {
          // float: left;
          // margin-right: 12px;
          padding-bottom: 20px;
          padding-top: 20px;
          border-bottom: 1px solid rgba(230, 230, 230, 1);
        }
        .Sales_Button {
          padding-bottom: 20px;
          padding-top: 20px;
        }
      }
    }
  }
}
</style>
